// removed by extract-text-webpack-plugin
module.exports = {"CustomIcon":"RoomLobby__CustomIcon__1jVLo"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/RoomLobby.css
// module id = 1677
// module chunks = 2